export const CartTypes = {
  SET_ITEM_COUNT: "SET_ITEM_COUNT",
}